import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useCaseList = () => {
    const [data, setData] = useState(undefined);
    const getCaseList = async (params) => {
        // Fetch branch list
        const list = await apiService.caseList(params);
        list && setData(list); // update data state
        return list;
    }

    return {
        data,
        getCaseList,
    }
}